import { createContext } from 'react'

const contextPayload = { onLoginUniquePass: () => undefined }
const PublicUserAuthProviderContext = createContext(contextPayload)

PublicUserAuthProviderContext.displayName = 'public-user-auth-provider_context'

export default PublicUserAuthProviderContext
